import { jsx, jsxs } from 'react/jsx-runtime';
import { LineIcon } from '../../ui/icons/LineIcon.js';
import { cn } from '../../../lib/utils.js';

const InfoCard = ({ text, subText, align = "left", className = "", onClick }) => {
  const handleClick = () => {
    console.log("ok");
    onClick?.();
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: cn(
        "flex items-start w-full border border-dashed overflow-hidden border-basic-03 rounded-md focus-visible:outline-offset-2",
        // align === 'left' && 'justify-center',
        align === "center" && "pr-7",
        className
      ),
      onClick: handleClick,
      children: /* @__PURE__ */ jsxs(
        "span",
        {
          className: cn(
            "body-md font-weight-medium relative text-basic-04 whitespace-pre-line pt-[16px] pb-[16px] pl-4 bg-base-white bg-cover pr-3",
            align === "left" && "w-full mx-0 text-left pr-2.5",
            align === "center" && "mx-auto text-center"
          ),
          children: [
            text,
            subText && /* @__PURE__ */ jsx("p", { children: subText }),
            /* @__PURE__ */ jsx(
              LineIcon,
              {
                icoColor: "bg-icon-basic-01",
                icoName: "ico-caret-right",
                type: "xs",
                className: cn(
                  "mt-[-3px] ",
                  align === "left" && "absolute right-[12px] top-[55%] translate-y-[-50%]"
                )
              }
            )
          ]
        }
      )
    }
  );
};

export { InfoCard };
